import { MessageDescriptor } from "react-intl";

import genericErrors from "./genericErrors";
import importValidationErrors from "./importErrors";
import importRequests from "./importRequests";
import visibility from "./visibility";

const messages: Record<PropertyKey, Pick<Required<MessageDescriptor>, "id" | "defaultMessage">> = {};
export default messages;

Object.assign(messages, genericErrors);
Object.assign(messages, importValidationErrors);
Object.assign(messages, importRequests);
Object.assign(messages, visibility);
